module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalVisible) ? _c('modal-dialog', {
    attrs: {
      "title": "Template Variable Reference",
      "modal-visible": _vm.modalVisible,
      "submit-visible": false
    },
    on: {
      "closeModal": _vm.close
    }
  }, [_c('table', {
    staticClass: "table table-striped table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Object")]), _vm._v(" "), _c('th', [_vm._v("Variable Name")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": _vm.client.length + 1
    }
  }, [_vm._v("client.")])]), _vm._v(" "), _vm._l((_vm.client), function(field) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(field))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": _vm.location.length + 1
    }
  }, [_vm._v("location.")])]), _vm._v(" "), _vm._l((_vm.location), function(field) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(field))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": _vm.company.length + 1
    }
  }, [_vm._v("company.")])]), _vm._v(" "), _vm._l((_vm.company), function(field) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(field))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": _vm.user.length + 1
    }
  }, [_vm._v("user.")])]), _vm._v(" "), _vm._l((_vm.user), function(field) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(field))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": _vm.date.length + 1
    }
  }, [_vm._v("date")])]), _vm._v(" "), _vm._l((_vm.date), function(field) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(field))])])
  })], 2)]), _vm._v(" "), _c('p', {
    pre: true,
    attrs: {
      "style": "margin-top: 10px;"
    }
  }, [_c('strong', [_vm._v("Example usage:")]), _vm._v(" {{company.email}}")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0843a528","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VariableHelp.vue
// module id = 263
// module chunks = 0